<template>
  <div>
    <form-input-container
      :title="$t('recovery.form.recovery-date')"
      :text="$t('recovery.form.recovery-date-description')">

      <date-picker
        v-model="recoveryDate"
        :min="minDate"
        :max="new Date().toISOString().substr(0, 10)" />
    </form-input-container>
  </div>
</template>

<script>

import New from '@/views/constants/recovery-new';
import Edit from '@/views/constants/recovery-edit';
import Compositions from '@/views/helpers/compositions';
import Helpers from '@/shared/helpers/functions';
import Modal from '@/shared/constants/modal';
import DatePicker from '@aevitae/aevitaeui/1_molecules/Input/DatePicker.vue';


import FormInputContainer from '@aevitae/aevitaeui/0_atoms/containers/FormInputContainer.vue';

export default {
  name: 'RecoveryForm',
  props: {
    isEditing: Boolean,
    reportOfSickness: Object
  },
  components: {
    FormInputContainer,
    DatePicker
  },
  data () {
    return {
      menu: false
    };
  },
  computed: {
    minDate () {
      let minimalReportOfSicknessDate = null;
      // adding 1 day to ensure a the date is the actual minimum
      // -> cannot add new report on date itself.
      if (this.isEditing) {
        minimalReportOfSicknessDate = Helpers.Dates.addDays(
          Compositions.getSecondLastDateFromReportOfSickness(this.reportOfSickness), 1);
      } else {
        minimalReportOfSicknessDate = Helpers.Dates.addDays(
          Compositions.getLatestDateFromReportOfSickness(this.reportOfSickness), 1);
      }

      return minimalReportOfSicknessDate;
    },

    recovery () {
      if (this.isEditing) {
        return this.$store.getters.editRecovery;
      } else {
        return this.$store.getters.newRecovery;
      }
    },

    recoveryDate: {
      set (value) {
        const latestIndemnity = Compositions.getLatestIndemnityProcessedDate(this.reportOfSickness);
        if (
          latestIndemnity != null &&
          new Date(value) < new Date(latestIndemnity)
        ) {
          this.$store.dispatch(Modal.Actions.OPEN, {
            component: 'StartDateBeforeIndemnityProcessedPickedForRecovery',
            reportOfSickness: this.reportOfSickness,
            recovery: this.recovery,
            isRecoveryEditing: this.isEditing,
            newValue: value
          });
        } else {
          if (this.isEditing) {
            this.$store.dispatch(Edit.Actions.Form.CHANGE, { attribute: 'recoveryDate', value: value }).then(
              this.$store.dispatch(Edit.Actions.Steps.Completed.UPDATE));
          } else {
            this.$store.dispatch(New.Actions.Form.CHANGE, { attribute: 'recoveryDate', value: value })
              .then(this.$store.dispatch(New.Actions.Steps.Completed.UPDATE));
          }
        }
      },
      get () {
        return this.recovery.recoveryDate;
      }
    }
  }
};
</script>
